import { render, staticRenderFns } from "./NewManufacturerForm.vue?vue&type=template&id=28c8344a"
import script from "./NewManufacturerForm.vue?vue&type=script&lang=js"
export * from "./NewManufacturerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports